"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { fetchThemeByOrigin } from "@theme-token/sdk";
import type { ClientTheme } from "@/lib/theme-resolver";

/**
 * Fetches a theme directly from the blockchain via @theme-token/sdk.
 * ordfs.network is a public API with CORS — no proxy needed.
 *
 * Returns the ThemeToken for use with ClientThemeProvider.
 */
export function useClientTheme(themeOrigin, initialTheme) {
  const $ = _c(12);
  let t0;
  if ($[0] !== themeOrigin) {
    t0 = ["client-theme", themeOrigin];
    $[0] = themeOrigin;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = initialTheme && initialTheme.themeOrigin === themeOrigin ? initialTheme : undefined;
  let t2;
  if ($[2] !== themeOrigin) {
    t2 = async () => {
      if (!themeOrigin) {
        return null;
      }
      const published = await fetchThemeByOrigin(themeOrigin);
      if (!published) {
        return null;
      }
      return {
        token: published.theme,
        themeOrigin
      };
    };
    $[2] = themeOrigin;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = !!themeOrigin;
  let t4;
  if ($[4] !== t0 || $[5] !== t1 || $[6] !== t2 || $[7] !== t3) {
    t4 = {
      queryKey: t0,
      initialData: t1,
      queryFn: t2,
      enabled: t3,
      staleTime: 300000,
      retry: 1
    };
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const result = useQuery(t4);
  const t5 = result.data ?? null;
  let t6;
  if ($[9] !== result.isLoading || $[10] !== t5) {
    t6 = {
      theme: t5,
      isLoading: result.isLoading
    };
    $[9] = result.isLoading;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
}